export const normalizeModelIdentifier = value => String(value || '').normalize('NFKC').toLowerCase().replace(/[^a-z0-9]/g, '');
// Similarity is only a review hint, never evidence that two model versions are interchangeable.
export const modelSuggestions = (models, draft) => {
  const wanted = [draft.modelName, draft.modelNumber].map(normalizeModelIdentifier).filter(Boolean);
  if (!wanted.length) return [];
  return models.map(model => {
    const identifiers = [model.modelName, model.modelNumber, [model.modelName, model.modelNumber].filter(Boolean).join(' - ')].map(normalizeModelIdentifier).filter(Boolean);
    const exact = wanted.some(value => identifiers.includes(value));
    const similar = wanted.some(value => value.length >= 4 && identifiers.some(saved => {
      let prefix = 0;
      while (prefix < Math.min(value.length, saved.length) && value[prefix] === saved[prefix]) prefix++;
      return saved.includes(value) || value.includes(saved) || prefix >= Math.max(4, Math.ceil(Math.max(value.length, saved.length) * 0.7));
    }));
    return { model, exact, similar };
  }).filter(row => row.exact || row.similar).sort((a,b) => Number(b.exact) - Number(a.exact)).slice(0,8);
};
